import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_146eae49: FaireBrandEntity = {
  token: "b_146eae49",
  type: "brand",
  name: "Sweetgum Home",
  avatarUrl:
    "https://cdn.faire.com/fastly/eda1412a875afb7faa7321b3db277d769eaa7707a2f5d21f3a40aa8ee5623034.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/38ac6708c5ee599a074f49c42cf931ca26489b482086907641d4c06f5005c42b.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/eda1412a875afb7faa7321b3db277d769eaa7707a2f5d21f3a40aa8ee5623034.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/38ac6708c5ee599a074f49c42cf931ca26489b482086907641d4c06f5005c42b.jpeg",
  location: "Hopkinton, MA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 57,
  isTopShop: true,
  isInsider: true,
  description:
    "Sweetgum Home creates eco-friendly, premium quality Swedish dishcloths + home goods.\n\nWe are a woman-owned small business (hi!👋🏼 ~Anne, owner & Sandra, lead designer).  \n\nWe design in New England and source in Europe.  We print our dishcloths in the lovely land of Finland using water based inks.\n\nWe hope our collections will inspire connections with friends & family in the heart of the home, the kitchen❤️.  And at the same time, do better for our shared home, planet Earth.\n\nWe personally appreciate every retail partner - and order - from kitchen shops who do a brisk business to smaller home & gift, garden, and book stores (and others!).  \n\nIf you have a question about our products or terms, please ask!  We'll be flexible whenever we can.\n\n⭐⭐⭐⭐⭐\n\"Your Swedish dishcloths are customer favorite in my shop!  They always sell quickly\".  \n\n\"I've been giving your dishcloths to friends for years, because they're not just another pretty object, but a very useful item.  Perfect little gift.\"\n\n* * *\nWhat's a Swedish dishcloth?\nThink of them as reusable paper towels, or an adorable alternative to a plastic sponge or rag\n- Tough enough to clean crumbs, spills and stubborn gunk off counters\n- Ultra absorbent, yet they dry super fast... goodbye icky wet sponge smells  \n- A single Swedish dishcloth can replace +15 rolls of disposable paper towels\n- Use ~6 months, then compost🌱 \n\nSweetgum is the proud USA Distributor for MORE JOY of Finland ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:43:53.184Z",
    importedBy: "entity-db-cli",
  },
};
